"use client";

import { Button, cn } from "@ubud-ui/react-ui-kit";
import { TButtonLink } from "../../types";
import Image from "next/image";
import Link from "next/link";

type ButtonLinkSize = "lg" | "md" | "sm";

type Props = TButtonLink & {
  size?: ButtonLinkSize;
  className?: string;
  iconClassName?: string;
};

export function ButtonLink({ href, text, target, icon, iconPosition, color, size = "sm", className, iconClassName }: Props) {
  const mapSizeClass: Record<ButtonLinkSize, string> = {
    sm: "text-base h-12",
    md: "text-base md:text-lg h-12 md:h-[50px]",
    lg: "text-lg md:text-xl h-14 md:h-[60px] md:px-8",
  };

  const additionalClass: Record<string, string> = {
    outline: "!text-gray-800",
  };

  return (
    <Button
      variant={color?.code || "secondary"}
      className={cn("py-4 px-6 font-bold", mapSizeClass[size], additionalClass[color?.code || "secondary"], className || "")}
      asChild
    >
      <Link href={href} target={target || "_self"}>
        {icon && iconPosition === "start" && (
          <Image
            className={cn("size-7 mr-1", iconClassName)}
            src={icon?.url || ""}
            alt={icon?.alternativeText || icon?.name || "Button Link"}
            width={icon?.width || 28}
            height={icon?.height || 28}
          />
        )}
        <span>{text}</span>
        {icon && iconPosition === "end" && (
          <Image
            className={cn("size-7 mr-1", iconClassName)}
            src={icon?.url || ""}
            alt={icon?.alternativeText || icon?.name || "Button Link"}
            width={icon?.width || 28}
            height={icon?.height || 28}
          />
        )}
      </Link>
    </Button>
  );
}
